import HorizontalLinearStepper from "@/views/elements/HorizontalLinearStepper"
import WrapperModal, { PropsTypeWrapperModal } from "@/views/elements/WrapperModal"
import { useEffect, useState } from "react"
import Step1 from "./Step1"
import Step2 from "./Step2"
import { useTranslation } from "react-i18next"
import { getMasterReviewUnregis } from "@/controllers/gridManager/masterTransManager/masterTransManager"
import { Skeleton } from "@mui/material"

export default function DeleteMasterAccount({ open, handleClose, data }: PropsTypeWrapperModal) {
    const { t } = useTranslation()
    const steps = [t('copytrade.common.confirm'), t('copytrade.common.finished')]
    const [activeStep, setActiveStep] = useState<number>(-1)
    const [predata, setPredata] = useState(null)

    const currentStep = activeStep + 1

    useEffect(() => {
        loaddata()
    }, [])

    const loaddata = async () => {
        let response = await getMasterReviewUnregis(data?.afacctno)
        if (response.isSuccess) {
            setPredata(response.data)
            setActiveStep(0)
        }
    }

    const handleNextStep = () => {
        setActiveStep(prevStep => prevStep + 1)
    }

    const preHandleClose = () => {
        if (currentStep === 2) {
            window.location.reload()
        } else {
            handleClose()
        }
    }

    return (
        activeStep < 0 ? <Skeleton variant="rectangular"></Skeleton> :
            <WrapperModal
                open={open}
                handleClose={preHandleClose}
                title={t('copytrade.portfolioManagement.deleteMasterAccount')}
            >
                <HorizontalLinearStepper
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                />
                {
                    currentStep === 1 && <Step1
                        close={preHandleClose}
                        next={handleNextStep}
                        data={predata}
                    />
                }

                {
                    currentStep === 2 && <Step2
                        close={preHandleClose}
                        msg={t('copytrade.portfolioManagement.acknowledgedRequest')}
                    />
                }

            </WrapperModal>
    )
}